export default "__VITE_ASSET__DuckLjEW__"